import type * as React from 'react'

import { CommonThread } from './CommonThread'
import type { ThreadComponentProps } from './types'

export const ThreadWithNoDragAndDrop = (props: ThreadComponentProps) => {
  const renderWrapper = (children: React.ReactNode): JSX.Element => (
    <>{children}</>
  )

  return (
    <CommonThread
      {...props}
      renderWrapper={renderWrapper}
      renderThreadItem={undefined}
    />
  )
}
